export default "__VITE_ASSET__Cz$4KVMR__"